import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useIsClient } from "@crehana/react-hooks";
import clsx from "clsx";
import { css } from "styled-components";
import { useMainMenuContext, useScreenLgBreakpoint } from "../hooks/index.js";
const SubmenuBackdrop = ()=>{
    const { theme, isTransparent, activeSubMenu, currentBreakpointKey, mainMenuVisibleHeight, topBannerVisibleHeight, onChangeStateOpenOverlay } = useMainMenuContext();
    const isClient = useIsClient();
    const { isLg, isEmbeddedInNewDashboard } = useScreenLgBreakpoint();
    const submenuIsOpen = 'catalog-menu' === activeSubMenu || 'solutions-menu' === activeSubMenu || 'degrees-menu' === activeSubMenu || 'left-menu-drawer' === activeSubMenu || 'notifications-drawer' === activeSubMenu || 'user-menu' === activeSubMenu && 'sm' === currentBreakpointKey;
    useEffect(()=>{
        if (onChangeStateOpenOverlay) onChangeStateOpenOverlay('CoursesExplorer', submenuIsOpen);
    }, [
        submenuIsOpen
    ]);
    if (!isClient || 'xs' === currentBreakpointKey) return null;
    const dynamicTopSpaceDependingOnTransparencyLg = isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.lg;
    const dynamicTopSpaceDependingOnBreakpointMd = isLg && isEmbeddedInNewDashboard ? dynamicTopSpaceDependingOnTransparencyLg : 0;
    return /*#__PURE__*/ jsx("div", {
        className: clsx('fixed inset-0 pointer-events-none', theme.submenu.backdropColorClassName, submenuIsOpen ? 'cui-is-visible' : 'cui-is-hidden', {
            'pointer-events-none': !submenuIsOpen
        }),
        css: css`
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        z-index: ${theme.nav.zIndex - 1};
        top: ${isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.xs}px;

        ${(props)=>props.theme.breakpoints.up('sm')} {
          top: 0;
        }

        ${(props)=>props.theme.breakpoints.up('md')} {
          top: ${dynamicTopSpaceDependingOnBreakpointMd}px;
        }

        ${(props)=>props.theme.breakpoints.up('lg')} {
          top: ${isTransparent ? topBannerVisibleHeight : mainMenuVisibleHeight.lg}px;
        }
      `
    });
};
const ui_SubmenuBackdrop = SubmenuBackdrop;
export default ui_SubmenuBackdrop;
